
const scheme = 'https'

const local_api_server_host = 'http://127.0.0.1:8080/neeuro-api'
const staging_portal_api_server_host = 'https://apicogolandstaging.neeuro.com'
const aliyun_staging_portal_api_server_host = 'http://47.111.29.11'
const aliyun_prod_portal_api_server_host = 'https://apicogoland.neeuro.tech'
const prod_portal_api_server_host = 'https://apicogoland.neeuro.com'

const config = {
  api_server_host: staging_portal_api_server_host,
  chart_onclick_enabled: false,
}

if(__DEV__) config.api_server_host = prod_portal_api_server_host
if(__STAGING__) config.api_server_host = staging_portal_api_server_host
if(__STAGING_CN__) config.api_server_host = aliyun_staging_portal_api_server_host
if(__PROD__) config.api_server_host = prod_portal_api_server_host
if(__PROD_CN__) config.api_server_host = aliyun_prod_portal_api_server_host

export default config



// WEBPACK FOOTER //
// ./src/config.js